import ContactosCRUD from '../components/ContactosCRUD.jsx';
export default function Clientes() {
  return <ContactosCRUD tipo="clientes" />;
}
